module.exports = __webpack_public_path__ + "static/img/weihai-index.ae475328.jpg";